// TODO: deprecate these constants. These colours should not used throughout the application
export const SECONDARY_COLOR = '#00c2a1' // Dark green
export const DISABLED_COLOR = '#9f9b9b' // Light grey
export const LIGHT_SECONDARY_COLOR = '#EBFBFF' // Light blue
